import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {ResponseCodeService} from '../../../../services/response-code.service';
import {NotificationService} from '../../../../services/notification.service';
import {AppState} from '../../../reducers';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {map, switchMap} from 'rxjs/operators';

import * as fromActions from './currency-type.actions';
import * as fromGraphql from './currency-type.graphql';

@Injectable()
export class CurrencyTypeEffects {

  createCurrencyType = createEffect(
    () =>
      this.actions$.pipe(ofType(fromActions.createCurrencyType), switchMap((action) => {
        return this.apollo
          .mutate({
            mutation: fromGraphql.CREATE_CURRENCY_TYPE,
            variables: {
              input: action?.input,
            },
          })
          .pipe(
            this.notificationService.catchError('Problem occurred while saving record'),
            map(({ data }: any) => {
              if (data) {
                const result: any = Object.values(data)[0];
                if (result?.response?.code == '9000') {
                  this.store.dispatch(
                    fromActions.upsertCurrencyType({
                      CurrencyType: result?.data,
                    })
                  );
                  return this.notificationService.successMessage('Created Successfully ');
                }

                this.notificationService.errorMessage(
                  result?.response?.message +
                  ' code:' +
                  result?.response?.code
                );
              }
            })
          );
      })
      ),
    { dispatch: false }
  );

  updateCurrencyType$ = createEffect(
    () =>
      this.actions$.pipe(ofType(fromActions.editCurrencyType), switchMap((action) => {
        return this.apollo
          .mutate({
            mutation: fromGraphql.UPDATE_CURRENCY_TYPE,
            variables: {
              input: action?.input,
            },
          })
          .pipe(
            this.notificationService.catchError('Problem occurred while updating record'), map(({ data }: any) => {
              if (data) {
                const result: any = Object.values(data)[0];
                if (result?.response?.code == '9000') {
                  this.store.dispatch(
                    fromActions.upsertCurrencyType({
                      CurrencyType: result?.data,
                    })
                  );
                  return this.notificationService.successMessage('Updated Successfully ');
                }

                this.notificationService.errorMessage(
                  result?.response?.message +
                  ' code:' +
                  result?.response?.code
                );
              }
            })
          );
      })
      ),
    { dispatch: false }
  );

  deleteCurrencyType$ = createEffect(
    () =>
      this.actions$.pipe(ofType(fromActions.removeCurrencyType), switchMap((action) => {
        return this.apollo
          .mutate({
            mutation: fromGraphql.DELETE_CURRENCY_TYPE,
            variables: {
              currencyUniqueId: action?.currencyUniqueId,
            },
          })
          .pipe(
            this.notificationService.catchError('Problem occurred while deleting record'), map(({ data }: any) => {
              if (data) {
                const result: any = Object.values(data)[0];
                if (result?.response?.code == '9000') {
                  this.store.dispatch(
                    fromActions.deleteCurrencyType({ id: action.id })
                  );
                  return this.notificationService.successMessage('Deleted Successfully');
                }

                this.notificationService.errorMessage(
                  result?.response?.message +
                  ' code:' +
                  result?.response?.code
                );
              }
            })
          );
      })
      ),
    { dispatch: false }
  );

  getCurrencyTypes$ = createEffect(
    () =>
      {

        return this.actions$.pipe(ofType(fromActions.getCurrencyTypes), switchMap((action) => {
          return this.apollo
            .query({
              query: fromGraphql.GET_CURRENCY_TYPES,
              fetchPolicy: 'network-only',
              variables:{
                instituionUniqueId:action.instituionUniqueId
              }
            })
            .pipe(
              this.notificationService.catchError('Problem occurred while fetching currency types'), map(({ data }: any) => {
                if (data) {
                  const result: any = Object.values(data)[0];
                  result?.response?.status
                    ? this.store.dispatch(
                      fromActions.loadCurrencyTypes({
                        CurrencyTypes: result?.data,
                      })
                    )
                    : [];
                }
              })
            );
        })
        )
      },
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) { }
}
